import React, { useEffect, useState } from "react";
import "./AddContentDetail.css";
import axios from "../../../axios";
import { iconData } from "../../../iconData";

export default function AddContentDetail({ setOpenSubject }) {
  const [categoryDropdown, setCategoryDropdown] = useState();
  const [title, setTitle] = useState();
  const [description, setDescription] = useState();
  const [categoryId, setCategoryId] = useState();
  const [fileInfoId, setFileInfoId] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  function getContentAfterSlash(url) {
    if (url) {
      const parts = url.split("/");
      return parts[parts.length - 1];
    }
  }
  useEffect(() => {
    const handleCategoryDropdown = async () => {
      let res = await axios.get(`/api/v1/cm/library/category/getAllCategory`);
      setCategoryDropdown(res.data.data);
    };
    handleCategoryDropdown();
  }, []);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];

    if (droppedFile) {
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "audio/mpeg",
        "video/mp4",
      ];

      if (!allowedTypes.includes(droppedFile.type)) {
        window.alert(
          "Invalid file type. Only PDF, JPEG, PNG, MP3, and MP4 files are allowed."
        );
        return;
      }

      const maxSizeInMB = droppedFile.type.startsWith("image") ? 5 : droppedFile.type === "audio/mpeg" ? 50 : 250;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      if (droppedFile.type === "application/pdf" && droppedFile.size > 50 * 1024 * 1024) {
        window.alert("PDF file size exceeds 50 MB.");
        return;
      } else if (droppedFile.size > maxSizeInBytes) {
        window.alert(`File size exceeds ${maxSizeInMB} MB.`);
        return;
      }

      handleFileChange({
        target: {
          files: [droppedFile],
        },
      });
    }
  };

  console.log(iconData?.find(
    (i) =>
      i.extension ===
      getContentAfterSlash(selectedFile?.type)
  )?.icon)

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    console.log(e.target.files);
    if (selectedFile) {
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "audio/mpeg",
        "video/mp4",
      ];
      if (!allowedTypes.includes(selectedFile.type)) {
        window.alert(
          "Invalid file type. Only PDF, JPEG, PNG, MP3, and MP4 files are allowed."
        );
        return;
      }
      const maxSizeInMB = selectedFile.type.startsWith("image")
        ? 5
        : selectedFile.type === "audio/mpeg"
          ? 50
          : 250;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      if (
        selectedFile.type === "application/pdf" &&
        selectedFile.size > 50 * 1024 * 1024
      ) {
        window.alert("PDF file size exceeds 50 MB.");
        return;
      } else if (selectedFile.size > maxSizeInBytes) {
        window.alert(`File size exceeds ${maxSizeInMB} MB.`);
        return;
      }
      setSelectedFile(selectedFile);
      handleUploadFile(selectedFile);
    }
  };
  const handleUploadFile = async (file) => {
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("content", file);
    formData.append("module_name", "library_media");

    try {
      const response = await axios.post(
        "/api/v1/school/library/uploadFile",
        formData
      );
      // Handle successful response if needed
      setFileInfoId(response.data.data.id);
    } catch (error) {
      // Handle error if needed
      console.error("Error uploading file:", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let body = {
      title: title,
      description: description,
      isProgressMandatory: true,
      visibility: true,
      fileInfoId: fileInfoId,
    };
    let res = await axios.post(
      `/api/v1/cm/library/category/addContent?category_id=${categoryId}`,
      body
    );
    if (res.data.status === true) {
      window.location.reload();
    }
  };
  const handleDisable = () => {
    if (title && description && fileInfoId && categoryId) {
      return false;
    } else {
      return true;
    }
  };
  return (
    <div className="totalContainer_addContent_detail">
      <div className="totalSubContainer_addContent_detail  p-4">
        <div className="addContent_heading">Add Content</div>
        <div className="">
          <input
            className="form-control input_chapter w-100"
            id={title?.length > 0 ? "byeInput" : "belloInput"}
            placeholder="Add title"
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            maxLength={50}
          />
        </div>
        <div className="">
          <input
            className="form-control input_chapter w-100"
            id={description?.length > 0 ? "byeInput" : "belloInput"}
            placeholder="Add description"
            onChange={(e) => {
              setDescription(e.target.value);
            }}
            maxLength={250}
          />
        </div>
        <div className="selectd_Categry">
          <select
            className="form-select mt-3 dorpdown_categroy "
            id={categoryId && categoryId !== "null" ? "bye" : "bello"}
            aria-label="Default select example"
            onChange={(e) => {
              setCategoryId(e.target.value);
            }}
          >
            <option value="null">Select Category</option>
            {categoryDropdown?.length > 0 &&
              categoryDropdown.map((obj) => (
                <option value={obj.id}>{obj.CategoryName}</option>
              ))}
          </select>
        </div>

        {selectedFile === null || selectedFile === undefined ? (
          <div
            className="col-12 mt-3 p-0"
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onDrop={(e) => {
              e.preventDefault();
              handleDrop(e);
            }}
          >
            <div className="" htmlFor="attachFile">
              <input
                type="file"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                id="attachFile"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label className="attach_categry" htmlFor="attachFile">
                Drag & drop file
              </label>
            </div>
          </div>
        ) : (
          <div className="attach_categry1 mt-4">
            <div className="hw_defult_attach_box ml-3 ">
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <img
                    className="mr-2 hw_defult_attach_type_icon"
                    // src={`/images/${attachment?.match(/\.([^.]+)$/)[1]}.svg`}
                    src={`${iconData?.find(
                      (i) =>
                        i.extension ===
                        getContentAfterSlash(selectedFile?.type)
                    )?.icon
                      }`}
                    alt="icon"
                  />
                  <div className="hw_default_attach_name">
                    <span>{selectedFile?.name}</span>
                  </div>
                </div>
                <img
                  className="attachment_cross_icon"
                  src="/images/attachment_cross_icon.png"
                  alt="icon"
                  onClick={() => {
                    setSelectedFile();
                  }}
                />
              </div>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-end mt-3">
          <button
            className={
              handleDisable()
                ? "add_to_libraryBtn_CmDisable"
                : "add_to_libraryBtn_Cm"
            }
            onClick={(e) => {
              handleSubmit(e);
            }}
          >
            Add to Library
          </button>
        </div>
      </div>

      <div className="CrossBtn_addContent">
        <img
          onClick={(e) => {
            setOpenSubject({ AddContent: false });
          }}
          src="/ContentM_images/cross_icon_cm.svg"
          alt="cross logo"
        ></img>
      </div>
    </div>
  );
}
